import React from "react";

const AdminLogin = () => {
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Admin Login</h2>
        <p>Coming soon...</p>
      </div>
    </div>
  );
};

export default AdminLogin;
